import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'
import App from './App'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      {/* Konvensi: semua notifikasi lewat sonner. Dilarang alert()/confirm()/prompt(). */}
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  </StrictMode>,
)
